import React, { useEffect, useState } from 'react'
import Navigation from './Router'
import ReactPixel from 'react-facebook-pixel'
import { Amplify } from 'aws-amplify'
import { Hub } from 'aws-amplify/utils'
import { signIn, fetchAuthSession, getCurrentUser } from '@aws-amplify/auth'
import ApiService from './ApiService'
import useUserStore from './hook/useUserStore'

ReactPixel.init('155837033166212')
ReactPixel.pageView()

const App = () => {
  const [loading, setLoading] = useState(false)
  const patient = useUserStore(state => state.patient)
  const setPatient = useUserStore(state => state.setPatient)
  const isAuth = useUserStore(state => state.isAuth)
  const setIsAuth = useUserStore(state => state.setIsAuth)

  useEffect(() => {
    setLoading(true)
    const checkUserSignedIn = async () => {
      try {
        const session = await fetchAuthSession()
        const idToken = session.tokens?.idToken
        if (idToken) {
          setIsAuth(true)
        } else {
          setIsAuth(false)
        }
      } catch (error) {
        setIsAuth(false)
      } finally {
        setLoading(false)
      }
    }
    checkUserSignedIn()
  }, [])

  useEffect(() => {
    if (isAuth !== true) {
      setLoading(false)
      return
    }

    setLoading(true)

    const getPatient = async () => {
      try {
        try {
          const session = await fetchAuthSession()
          const idToken = session.tokens?.idToken
          if (!idToken) {
            setIsAuth(false)
            setLoading(false)
            return
          }
        } catch {
          setIsAuth(false)
          setLoading(false)
          return
        }
        const res = await ApiService.getPatientAfterSessRef()
        setPatient(res.data)
      } catch (err) {
        setPatient(null)
      } finally {
        setLoading(false)
      }
    }

    getPatient()
  }, [isAuth])

  useEffect(() => {
    const listener = data => {
      switch (data.payload.event) {
        case 'signIn':
          if (isAuth !== true) setIsAuth(true)
          break
        case 'signOut':
          setIsAuth(false)
          break
        default:
        // do nothing
      }
    }

    const unsubscribe = Hub.listen('auth', listener)

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <div className="App">
      <Navigation loginStatus={isAuth} />
    </div>
  )
}

export default App
